module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	exports.post = post;
	exports.postToIframe = postToIframe;
	var uniqueId = function () {
	    var counter = 0;
	    return function (prefix) {
	        return prefix + '-' + counter++;
	    };
	}();

	function addAttributes(element) {
	    var attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	    Object.keys(attributes).forEach(function (attr) {
	        var attributeValue = attributes[attr];
	        element[attr] = attributeValue;
	    });
	}

	function appendElementToDOM(element) {
	    var baseElement = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.body;

	    baseElement.appendChild(element);
	}

	function removeElementFromDOM(element) {
	    element.parentNode.removeChild(element);
	}

	function setUpForm(url) {
	    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	    var form = document.createElement('form');
	    form.style.display = 'none';

	    addAttributes(form, _extends({
	        method: 'post',
	        action: url,
	        enctype: 'multipart/form-data'
	    }, attributes));

	    Object.keys(data).forEach(function (key) {
	        var keyValue = data[key];

	        var input = void 0;
	        if (keyValue instanceof window.HTMLInputElement) {
	            input = keyValue.cloneNode();
	            addAttributes(input, { name: key });
	        } else {
	            input = document.createElement('input');
	            addAttributes(input, {
	                type: 'text',
	                name: key,
	                value: keyValue
	            });
	        }

	        form.appendChild(input);
	    });

	    return form;
	}

	function setUpIframe() {
	    var attributes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	    var iframe = document.createElement('iframe');
	    iframe.style.display = 'none';
	    addAttributes(iframe, attributes);
	    return iframe;
	}

	function post(url, data) {
	    var form = setUpForm(url, data);
	    appendElementToDOM(form);
	    form.submit();
	};

	function postToIframe(url, data) {
	    var target = uniqueId('Iframe-Post');
	    var iframe = setUpIframe({ name: target });
	    var form = setUpForm(url, data, { target: target });

	    appendElementToDOM(iframe);
	    appendElementToDOM(form);

	    var responsePromise = new Promise(function (resolve) {
	        iframe.onload = function () {
	            resolve();
	            removeElementFromDOM(iframe);
	            removeElementFromDOM(form);
	        };
	    });
	    form.submit();
	    return responsePromise;
	};

/***/ }
/******/ ]);


//////////////////
// WEBPACK FOOTER
// ./~/dibs-xdomain-poster/dist/bundle.js
// module id = 929
// module chunks = 63